import "./image_side_content.css";
